<h2 mat-dialog-title class="merge-dialog-title">
  <mat-icon>swap_horiz</mat-icon>
  Злити компетенцію
</h2>

<mat-dialog-content class="merge-dialog-content">
  <p class="merge-dialog-info">
    Компетенція <strong>{{ data.competence.name }}</strong> буде злита в обрану: всі кандидати й вакансії читатимуться
    через неї. Цю дію неможливо скасувати з панелі.
  </p>

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Пошук компетенції</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [formControl]="searchControl" placeholder="Введіть назву..." />
  </mat-form-field>

  <mat-form-field appearance="outline" class="target-field">
    <mat-label>Злити у компетенцію</mat-label>
    <mat-select [formControl]="targetControl">
      @let competences = filteredCompetences$ | async; @if (isLoading()) {
      <mat-option disabled>Завантаження компетенцій...</mat-option>
      } @else { @for (competence of competences; track competence.id) {
      <mat-option [value]="competence.id">{{ competenceLabel(competence) }}</mat-option>
      } @empty {
      <mat-option disabled>Компетенцій не знайдено</mat-option>
      } }
    </mat-select>
    @if (targetControl.invalid && targetControl.touched) {
    <mat-error>Оберіть компетенцію для злиття</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Скасувати</button>
  <button
    mat-raised-button
    color="warn"
    type="button"
    (click)="onConfirm()"
    [disabled]="targetControl.invalid || isLoading()"
  >
    Злити
  </button>
</mat-dialog-actions>
